<!-- NEW DIALOG -->
<p-dialog
	*ngIf="isDialogVisible && !severeError"
	header="{{ formTitle | uppercase }}"
	[(visible)]="isDialogVisible"
	[transitionOptions]="'150ms cubic-bezier(0, 0, 0.2, 1)'"
	[modal]="true"
	[draggable]="false"
	[resizable]="false"
	[closeOnEscape]="false"
	(visibleChange)="onVisibleChange()"
	[style]="{ width: '80vw' }"
>
	<!-- FORM ERRORS -->
	<div #errorContainer>
		<div *ngIf="errorMessages.length !== 0">
			<div *ngFor="let error of errorMessages">
				<div class="alert alert-warning" role="alert">{{ error }}</div>
			</div>
		</div>
	</div>

	<div class="d-flex flex-column gap-3 p-3">
		<!--==== SELECCIÓ FITXER ORIGEN ============================-->
		<p-card class="w-100">
			<!-- fichero -->
			<div class="d-flex row-cols-1 w-100">
				<!-- 1st COL -->
				<div class="d-flex ps-3 align-items-center">
					<div class="d-flex flex-column mb-3">
						<!-- Fitxer Excel -->
						<div class="p-2 align-items-center">
							<form-input
								[required]="true"
								[align]="'cols-2'"
								fieldName="{{ 'general.selectFile' | translate }}"
							>
								<input
									pInputText
									[disabled]="false"
									[readonly]="true"
									[ngModel]="documentFile ? documentFile.name : null"
									[style]="{ width: '500px', 'margin-right': '5px' }"
								/>
								<button
									id="uploadDocumentButton"
									class="btn btn-outline-dark"
									(click)="uploadDocumentInput.click()"
									[disabled]="selectedSourceType === '' || selectedSourceType === null"
								>
									...
								</button>
								<input
									#uploadDocumentInput
									[hidden]="true"
									type="file"
									accept=".xlsx,.xls,.csv"
									(change)="changeDocument($event)"
								/>
							</form-input>
						</div>
					</div>
				</div>
			</div>
		</p-card>
	</div>

	<!--==== CONFIGURACIÓ MAPPING ============================-->
	<div class="d-flex flex-column gap-3 p-3">
		<div *ngIf="start && (!loadedEntity || !loadedExcel)" class="d-flex flex-column gap-3 p-3">
			<div class="d-flex row-cols-1 w-100">
				<div class="d-flex ps-3 align-items-center">
					{{ 'general.loading' | translate }}
				</div>
			</div>
		</div>

		<p-panel *ngIf="start && loadedEntity && loadedExcel" class="w-100">
			<!-- SECCION 1: Seleccio fitxer i tipus -->
			<div class="d-flex row-cols-3 w-100">
				<!-- COL 1 -->
				<div class="d-flex ps-3 align-items-center">
					<div class="d-flex flex-column mb-3">
						<!-- capçalera -->
						<div class="p-2 align-items-center">
							<strong>{{ 'logistics.orders.importExcel.column' | translate }}</strong>
						</div>
						<!-- columna Excel -->
						<div class="p-2 align-items-center" *ngFor="let col of columnList">
							<input
								pInputText
								[disabled]="false"
								[readonly]="true"
								[ngModel]="col"
								[style]="{ width: '250px', 'margin-right': '5px' }"
							/>
						</div>
					</div>
				</div>
				<!-- COL 2 -->
				<div class="d-flex ps-3 align-items-center">
					<div class="d-flex flex-column mb-3">
						<!-- capçalera -->
						<div class="p-2 align-items-center">
							<strong>{{ 'logistics.orders.importExcel.field' | translate }}</strong>
						</div>
						<!-- camp Entitat -->
						<div class="p-2 align-items-center" *ngFor="let col of columnList; index as i">
							<p-dropdown
								[options]="fieldList"
								[(ngModel)]="selectedField[i]"
								placeholder="Select..."
								[style]="{ width: '250px', 'margin-right': '5px' }"
								appendTo="body"
								filter="true"
								filterBy="col"
								[disabled]="isEditingDisabled"
								(onChange)="onChangeField($event, i)"
								[class]="componentClass[i]"
							>
							</p-dropdown>
							<button
								*ngIf="selectedField[i]"
								class="btn custom-expand-button"
								type="button"
								alt="Remove"
								(click)="onRemoveField(i)"
							>
								<svg-icon
									[disabled]="isEditingDisabled"
									[ngClass]="{ rotated: !expanded }"
									class="d-flex m-0 p-0 custom-expand-button-icon"
									src="assets/icons/remove.svg"
									[svgStyle]="{ 'height.px': 20, 'width.px': 20 }"
								></svg-icon>
							</button>
						</div>
					</div>
				</div>
				<!-- COL 3 -->
				<div class="d-flex ps-3 align-items-center">
					<div class="d-flex flex-column mb-3">
						<!-- capçalera -->
						<div class="p-2 align-items-center">
							<strong>{{ 'logistics.orders.importExcel.sample' | translate }}</strong>
						</div>
						<!-- mostra -->
						<div class="p-2 align-items-center" *ngFor="let col of columnList; index as i">
							<input
								pInputText
								[disabled]="false"
								[readonly]="true"
								[ngModel]="sampleList[i]"
								[style]="{ width: '250px', 'margin-right': '5px' }"
							/>
						</div>
					</div>
				</div>
			</div>

			<!-- PIE DE PAGINA -->
			<p-footer>
				<div class="d-flex justify-content-between bd-highlight">
					<div class="p-2 bd-highlight">
						<p-checkbox
							binary="true"
							label="{{ 'logistics.orders.importExcel.defaultMapping' | translate }}"
							[(ngModel)]="defaultMapping"
							[disabled]="defaultMapping"
							(onChange)="onChangeDefaultMapping($event)"
						>
						</p-checkbox>
					</div>
					<div class="p-2 bd-highlight">
						<button
							type="button"
							class="btn custom-button"
							(click)="preview()"
							[disabled]="isEditingDisabled || !isSaveGranted || !previewReady"
						>
						{{buttonview}}
						</button>
					</div>
				</div>
			</p-footer>
		</p-panel>
	</div>

	<!--==== LLISTA DE ORDERS ============================-->
	<div class="d-flex flex-column gap-3 p-3">
		<div *ngIf="previewReady && loadedEntity && loadedExcel && previewSpinner" class="d-flex flex-column gap-3 p-3">
			<div class="d-flex row-cols-1 w-100">
				<div class="d-flex ps-3 align-items-center">
					{{ 'general.loading' | translate }}
				</div>
			</div>
		</div>
		<p-table
			*ngIf="generateReady && loadedEntity && loadedExcel && !previewSpinner"
			id="orders-table"
			[columns]="cols"
			[value]="dinamicList"
			class="custom-table"
			styleClass="p-datatable-striped"
		>
			<!-- TABLE COLUMN DEFINITION -->
			<ng-template pTemplate="header" let-columns>
				<!-- HEADERS -->
				<tr>
					<th *ngFor="let col of columns">
						<div [style]="{ 'margin-left': '10px', 'margin-right': '10px', 'text-align': 'center' }">
							{{ 'events.excel.' + col.header   | translate }}
						</div>
					</th>
				</tr>
			</ng-template>

			<!--	!-- TABLE BODY    class="p-selectable-row custom-rows custom-rows-small " -->
			<ng-template pTemplate="body" let-row let-columns="columns">
				<tr   [ngClass]="{'custom-rows-small' : authenticationService?.user?.tableSize === 'SMALL' }">
					<!-- {{ row.contents[0].productCode }} -->
					<td
						*ngFor="let col of columns"
						[ngClass]="{ rowGreen: result && !row.error, rowRed: result && row.error }"
					>
						<div *ngIf="col.type === 'date'">
							{{ (col.subfield ? row[col.field]?.[col.subfield] : row[col.field]) | date:'dd-MM-yyyy' }}
						</div>
						<div *ngIf="col.type === 'number'" [style]="{ 'text-align': 'right' }">
							{{ ((col.subfield ? row[col.field]?.[col.subfield] : row[col.field]) | number: '1.2-5').replace('.',',') }}
						</div>
						<div *ngIf="col.type === 'string'">
							{{ col.subfield ? row[col.field]?.[col.subfield] : row[col.field] }}
						</div>
					</td>
				</tr>
			</ng-template>

			<!-- TABLE EMPTY MESSAGE -->
			<ng-template pTemplate="emptymessage">
				<tr>
					<td [attr.colspan]="tableColspan" class="p-0">
						<div
							class="d-flex align-items-center justify-content-center h-100 p-5 custom-empty-orders-message"
							i18n
						>
							{{ 'table.tableEmptyMessage' | translate }}!
						</div>
					</td>
				</tr>
			</ng-template>

			<!-- FOOTER -->
			<ng-template pTemplate="footer">
				<tr>
					<td [attr.colspan]="tableColspan" class="p-0">
						<div class="d-flex justify-content-between bd-highlight">
							<div class="p-2 bd-highlight">
								<button
									type="button"
									class="btn custom-button"
									(click)="process()"
									[disabled]="isEditingDisabled || !isSaveGranted || generateSpinner || newgenerate"
								>
								{{buttongenerate}}
								</button>
								<span *ngIf='generateSpinner' [style]="{ 'margin-left': '20px' }">{{ 'general.wait' | translate }}</span>
							</div>
						</div>
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</p-dialog>
